import type { BusinessQuery } from '@/modules/dashboard/dashboardTypes';
import { sendAnalytics } from '@/services/analyticsService';
import { useState, createContext, useContext, ReactNode } from 'react';

type ListDetailsFiltersProviderContextType = {
	appliedFilters: BusinessQuery | undefined;
	onFiltersChange: (filters: BusinessQuery) => void;
};

const ListDetailsFiltersProviderContext = createContext<
	ListDetailsFiltersProviderContextType | undefined
>(undefined);

export const ListDetailsFiltersProvider = ({
	children
}: {
	children: ReactNode;
}) => {
	const [appliedFilters, setAppliedFilters] = useState<
		BusinessQuery | undefined
	>(undefined);

	const onFiltersChange = ({
		skip = 0,
		limit = 50,
		...filters
	}: BusinessQuery) => {
		const newQuery = {
			skip,
			limit,
			...filters
		};

		setAppliedFilters(newQuery);

		sendAnalytics({
			type: 'track',
			eventName: 'User changed filters',
			properties: {
				filterChanged: 'Has email',
				value: 'Included',
				query: newQuery
			}
		});
	};

	return (
		<ListDetailsFiltersProviderContext.Provider
			value={{
				appliedFilters,
				onFiltersChange
			}}
		>
			{children}
		</ListDetailsFiltersProviderContext.Provider>
	);
};

export const useListDetailsFiltersContext = () => {
	const context = useContext(ListDetailsFiltersProviderContext);

	if (!context) {
		throw new Error(
			'useFiltersContext must be used within a <ListDetailsFiltersProvider> component'
		);
	}

	return context;
};
